// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 28) return "static/chunks/28.e61e813d61b91642.js";
	if (chunkId === 281) return "static/chunks/281.71929cd0f0992512.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"59":"6136d0f449e06f03","431":"29564a12b8cca8e4","592":"05ab3d4d3b285384","704":"7a39f83f8b62f786","939":"163c022470a9e51a"}[chunkId] + ".js";
};